<div style=" display: flex; justify-content: center; height: 100%; align-items: center;">
    <h2 style="text-align: center;">{{ 'WIDGETS.SETTINGS_LABELS.NO_OPTIONS'|translate }}</h2>
</div>

